import { useEnv } from '../composables/useEnv'
const { apiUrl } = useEnv()

const API_KEY = 'CG-TGDqkhEAEsgmvPDdCSooDrv9'
const BASE_URL = 'https://api.coingecko.com/api/v3'
const MARKUP_PERCENTAGE = 40

interface PriceResponse {
  [key: string]: {
    inr: number;
    last_updated_at: number;
  }
}

interface PriceInfo {
  coingeckoPrice: number;  // Original price from CoinGecko
  ourPrice: number;        // Price after adding 10%
}

export async function getLRSPrice(): Promise<PriceInfo> {
  try {
    const searchResponse = await fetch(
      `${BASE_URL}/search?query=larissa`, {
        headers: {
          'x-cg-demo-api-key': API_KEY
        }
      }
    )

    if (!searchResponse.ok) {
      throw new Error('Failed to search for LRS')
    }

    const searchData = await searchResponse.json()
    const coinId = searchData.coins?.[0]?.id

    if (!coinId) {
      throw new Error('LRS coin not found')
    }

    const priceResponse = await fetch(
      `${BASE_URL}/simple/price?ids=${coinId}&vs_currencies=inr&include_last_updated_at=true`, {
        headers: {
          'x-cg-demo-api-key': API_KEY
        }
      }
    )

    if (!priceResponse.ok) {
      throw new Error('Failed to fetch LRS price')
    }

    const data: PriceResponse = await priceResponse.json()
    let coingeckoPrice = data[coinId]?.inr

    // if(coingeckoPrice < 2){
    //   coingeckoPrice = 2
    // }

    if (!coingeckoPrice) {
      throw new Error('Price data not available')
    }

    // Calculate our price with 10% markup
    const ourPrice = coingeckoPrice * (1 + MARKUP_PERCENTAGE / 100)

    return {
      coingeckoPrice,
      ourPrice
    }

  } catch (error) {
    console.error('Error fetching LRS price:', error)
    // Default fallback prices
    return {
      coingeckoPrice: 2.66,
      ourPrice: 2.83
    }
  }
}

// Optional: Add a function to get coin info for verification
export async function verifyLRSCoin(): Promise<void> {
  try {
    const response = await fetch(
      `${BASE_URL}/search?query=larissa`, {
        headers: {
          'x-cg-demo-api-key': API_KEY
        }
      }
    )

    if (!response.ok) {
      throw new Error('Failed to fetch coin info')
    }

    const data = await response.json()
    console.log('Available coins:', data.coins)
  } catch (error) {
    console.error('Error verifying LRS coin:', error)
  }
}

export const fetchPrice = async () => {
  try {
    const response = await fetch(`${apiUrl}/api/price`)
    return await response.json()
  } catch (error) {
    console.error('Error fetching price:', error)
    throw error
  }
}